import { placeholderPattern } from './placeholder';

interface Args {
  template: string;
  values: Record<string, string>;
}

/** Every `{{field}}` becomes the matching value, encoded for a query string. */
export const fillPlaceholders = ({ template, values }: Args): string =>
  template.replace(placeholderPattern, (_, key: string) =>
    encodeURIComponent(values[key] ?? ''),
  );
